module.exports = __webpack_public_path__ + "img/FIN.c513a79f.svg";